import React, { Component } from 'react';
import ApiService from "../service/ApiService";
import AuthService from '../service/AuthService' ;


class FinalQuoteComponent extends Component {

    constructor(props) {
        super(props)
        this.state = {
             isSuccess : false,
             loading : false,
             loadingSave : false,
             successSave : false,
             currentUser: undefined
        }
        this.initializeDevis = this.initializeDevis.bind(this);
        this.saveDevis = this.saveDevis.bind(this);
        this.getCurrentUser = this.getCurrentUser.bind(this);
        

       
    }

    componentDidMount() {
        this.initializeDevis();
        this.getCurrentUser();
    }

    getCurrentUser() {
        const user = AuthService.getCurrentUser();
      
        if (user) {
          this.setState({
            currentUser: user
          });
        }
      
      }

    initializeDevis() {
      
      this.setState({loading: true});

      let risque = JSON.parse(window.localStorage.getItem("risqueGar"));
           

      ApiService.initializeDevis(risque)
          .then(res => {
              let isErr = res.data.errorMessage ? true : false;
              if (!isErr) {
                let garantiesTriees = res.data.result.garanties;
                garantiesTriees.sort((a,b)=>{ return a.ordre-b.ordre;}); 
                  this.setState({
                      loading : false, 
                      message : res.data.message,
                      garanties : garantiesTriees,
                      primeNette : res.data.result.primeNette,
                      primeTTC : res.data.result.primeTTC,
                      taxesAccessoires : res.data.result.taxesAccessoires,
                      idDevis : res.data.result.idDevis,
                      isSuccess: true
                  });
               } else {
                  this.setState({message: res.data.errorMessage});
                  this.setState({isSuccess: false});
                  this.setState({loading: false});
               }
          }).catch(error => {
              //console.log(error);
              this.setState({
                  loading : false, 
                  message : error.message,
                  isSuccess: false
              });
          })
    }

    saveDevis(e) {
      
        e.preventDefault();
        this.setState({loadingSave: true, successSave : false});
  
        let idDevis = this.state.idDevis;
             
  
        ApiService.saveDevis(idDevis)
            .then(res => {
                let isErr = res.data.errorMessage ? true : false;
                if (!isErr) { 
                    this.setState({
                        loadingSave : false, 
                        successSave : true,
                        message : res.data.message
                    });
                    
                 } else {
                    this.setState({message: res.data.errorMessage});
                    this.setState({loadingSave: false,successSave : false});
                 }
            }).catch(error => {
                //console.log(error);
                this.setState({
                    loadingSave : false, 
                    successSave : false,
                    message : error.message
                });
            })
      }

    render() {

        return (
            <div class = "mt-3 py-3">
            {this.state.loading && ( 
            <div class="text-center container mb-4 mt-4">
            <div class="spinner-border text-danger" style={{"width": "4rem", "height": "4rem"}} role="status">
                <span class="sr-only">Chargement en cours...</span>
            </div>  
            </div>
            )}
            {!this.state.loading && (
                <div class="container mb-4 mt-4">
                  <div
                    className={
                      this.state.isSuccess
                        ? "alert alert-success alert-dismissible fade show"
                        : "alert alert-danger alert-dismissible fade show"
                    }
                    style = {{'white-space': 'pre-wrap'}}
  
                    role="alert"
                  >
                    {this.state.isSuccess ? <strong>OK! </strong> : <strong>KO! </strong> }
                    {this.state.message}
                    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>
              )}
            {!this.state.loading && this.state.isSuccess && (
            <div class="jumbotron text-center hoverable p-4 bg-light" >


              <div class="row">

                
                <div class="col-xd-6 offset-md-1 mx-1 my-1">

                <div class="card card-pricing text-center px-3 mb-4 shadow" >
                      <span class="h6 w-60 mx-auto px-4 py-1 rounded-bottom bg-success text-white shadow-sm"></span>
                      <div class="bg-transparent card-header pt-4 border-0">
                          <h1 class="h1 font-weight-normal text-primary text-center mb-0">MAD<span class="price">{this.state.primeTTC}</span><span class="h6 text-muted ml-2"> TTC/année</span></h1>
                      </div>
                      <div class="card-body pt-0">
                      <div class="table-responsive-sm">
                          <table className="table table-hover table-sm">
                          <thead>
                              <tr>
                                  <th>Garantie</th>
                                  <th>Capital assuré</th>
                                  <th>Franchise</th>
                              </tr>
                          </thead>
                          <tbody>
                         { this.state.garanties.map(garantie => (
                           <tr key={garantie.code}>
                           <td>{garantie.libelle}</td>
                           <td>{garantie.valeurAssuree}</td>
                           <td>{garantie.franchise}</td>
                           </tr>
                            ))}
                          </tbody>
                          </table>
                          </div>
                          <button type="button" class="btn btn-info mb-3 disabled">Sélectionné</button>
                  </div>
                  </div>

                </div>
                

              
                <div class="col-md-6 text-md-left ml-3 mt-3">

                  
                  <a href="{#}" class="text-success">
                         <h6 class="h6 pb-1"><i class="fa fa-check"></i>{this.state.message}</h6>
                  </a>

                  <h4 class="h4 mb-4">Votre prime TTC est de {this.state.primeTTC} MAD dont taxes {this.state.taxesAccessoires} MAD</h4>
                  {this.state.currentUser ?    
                <React.Fragment>
                    <button className="btn btn-info " disabled={this.state.loadingSave} onClick={this.saveDevis}> Enregistrer Devis</button>
                    {this.state.loadingSave && (<span className="spinner-border spinner-border-sm"></span> )}
                </React.Fragment> 
                : (
                  <p >Vous vous êtes déjà inscrit ? <a href = "{#}"><strong>connectez vous</strong></a> pour sauvegarder votre devis 
                  <br/> Si vous ne l'êtes pas encore, Inscivez-vous par <a href ="{#}" class="btn btn-success">ici</a></p>
                    )
                  }
                  
                  

                </div>
                


            </div>
          </div>
          )}
          </div>

        );
    }

}

export default FinalQuoteComponent;